import medicalHistorySetService from "@/Services/medicalHistorySets.service";
import gfeService from "@/Services/gfe.service";

const state = {};

const getters = {};

const mutations = {};

const actions = {
  async fetchMedicalHistorySets({ commit }) {
    return await medicalHistorySetService.fetchMedicalHistorySets();
  },
  async createMedicalHistorySet({ commit }, medicalHistorySet ) {
    const response = await medicalHistorySetService.createMedicalHistorySet(medicalHistorySet);
    return response;
  },
  async deleteMedicalHistorySetById({ commit }, { id }) {
    const response = await medicalHistorySetService.deleteMedicalHistorySet(id);
    return response;
  },
  async fetchMedicalHistorySetById({ commit },  id ) {
    const response = await medicalHistorySetService.fetchMedicalHistorySetId(id);
    return response;
  },
  async addMedicalHistorySetQuestions({ commit }, { id, questions }) {
    const response = await medicalHistorySetService.addMedicalHistorySetQuestions({ id, questions });
    return response;
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
